import plyr from 'plyr';

plyr.setup(document.querySelectorAll('.figure__video'), {
  loadSprite: false,
  i18n: {
    restart: 'Neustarten',
    rewind: '{seektime} Sekunden zurückspulen',
    play: 'Abspielen',
    pause: 'Pausieren',
    forward: '{seektime} Sekunden vorspulen',
    buffered: 'vorgeladen',
    currentTime: 'Aktuelle Abspielzeit',
    duration: 'Länge',
    volume: 'Lautstärke',
    toggleMute: 'Ton an-/abschalten',
    toggleCaptions: 'Untertitel an-/abschalten',
    toggleFullscreen: 'Vollbild an-/abschalten',
  },
  iconPrefix: 'icon',
  controls: [
    'play-large', // The large play button in the center
    'play', // Play/pause playback
    'progress', // The progress bar and scrubber for playback and buffering
    'current-time', // The current time of playback
    'duration', // The full duration of the media
    'mute', // Toggle mute
    'volume', // Volume control
    'captions', // Toggle captions
    'fullscreen', // Toggle fullscreen
  ],
});
